import React from 'react';
import Datetime from 'react-datetime';
import 'flatpickr/dist/themes/material_green.css'
import { Col, Row, Form, Button, Accordion, Card, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faUndoAlt, faFileCsv, faFilePdf, faFileExcel } from '@fortawesome/free-solid-svg-icons';
import 'react-bootstrap-multiselect/css/bootstrap-multiselect.css'
import moment from 'moment';
import './react-datetime.css';
import './Filter.css';

const Filter = (props) => {
  const {merchantCustNo, fromDate, toDate,
    statusCode, payerAccount, customerAcctCurrency } = props.criteria;
  
  const {isDownloading} = props;

  return (
    <React.Fragment>
      {/* <Accordion defaultActiveKey="0">
      <Card className="border-0"> 
        <Card.Header>
          <Accordion.Toggle as={Button} variant="link" className="link" eventKey="0">
            Filter
          </Accordion.Toggle>
        </Card.Header>
        <Accordion.Collapse eventKey="0">
          <Card.Body> */}
            <Row>
              <Col sm={2} className="pr-0">
                <Form.Group controlId="fromDate">
                  <Form.Label className="text-grey font-weight-bold medium">From</Form.Label>
                  <Datetime
                    onChange={(date) => {
                      const dateStr = moment.isMoment(date) ? date.format("YYYYMMDDHHmmss") : date;
                      props.onChange({ target: { name: 'fromDate', value: dateStr } })
                    }}
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    value={moment(fromDate, "YYYYMMDDHHmmss", true).isValid() ? moment(fromDate, "YYYYMMDDHHmmss", true) : fromDate}
                  />
                </Form.Group>
              </Col>
              <Col sm={2} className="pr-0">
                <Form.Group controlId="toDate">
                  <Form.Label className="text-grey font-weight-bold medium">To</Form.Label>
                  <Datetime
                    onChange={(date) => {
                      const dateStr = moment.isMoment(date) ? date.format("YYYYMMDDHHmmss") : date;
                      props.onChange({ target: { name: 'toDate', value: dateStr } })
                    }}
                    dateFormat="DD/MM/YYYY"
                    timeFormat="HH:mm"
                    value={moment(toDate, "YYYYMMDDHHmmss", true).isValid() ? moment(toDate, "YYYYMMDDHHmmss", true) : toDate}
                  />
                </Form.Group>
              </Col> 
              <Col sm={2} className="pr-0">
                <Form.Group controlId="merchantCustNo">
                  <Form.Label className="text-grey font-weight-bold medium">Customer No.</Form.Label>
                  <Form.Control type="text" name="merchantCustNo" value={merchantCustNo} onChange={props.onChange} placeholder="Customer no." />
                </Form.Group>
              </Col>
            </Row>
            <Row>  
              <Col sm={2} className="pr-0">
                <Form.Group controlId="payerAccount">
                  <Form.Label className="text-grey font-weight-bold medium">Customer Account No.</Form.Label>
                  <Form.Control type="text" name="payerAccount" value={payerAccount} onChange={props.onChange} placeholder="Customer account" />
                </Form.Group>
              </Col>
              <Col sm={2} className="pr-0">
                <Form.Group controlId="statusCode">
                  <Form.Label className="text-grey font-weight-bold medium">Status</Form.Label>
                  <Form.Control as="select"
                    name="statusCode"
                    value={statusCode}
                    onChange={props.onChange}>
                    <option value="">All</option>
                    <option value='0000'>Success</option>
                    <option value='0001'>Initiated</option>
                    <option value='0002'>Verified Passed</option>
                    <option value='0003'>Verified Failed</option>
                    <option value='0004'>Term and Conditions</option>
                    <option value='0005'>Request OTP</option>
                    <option value='0006'>OTP Failed</option>
                    <option value='0007'>Canceled</option>
                    <option value='9999'>Error</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col sm={2} className="pr-0">
                <Form.Group controlId="customerAcctCurrency">
                  <Form.Label className="text-grey font-weight-bold medium">Account Currency</Form.Label>
                  <Form.Control as="select"
                    name="customerAcctCurrency"
                    value={customerAcctCurrency}
                    onChange={props.onChange}>
                    <option value="">All</option>
                    <option value='FCD'>FCD</option>
                    <option value='THB'>THB</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            
              <Col sm={2} className="pr-0" className="pr-0 pt-1 mt-4">
                <Button type="button" variant="link" className="link" onClick={props.onSubmit}>
                  <FontAwesomeIcon size="lg" icon={faSearch} />
                </Button>
                <Button type="button" variant="link" className="link" onClick={props.onReset}>
                  <FontAwesomeIcon size="lg" icon={faUndoAlt} />
                </Button>
                <Button disabled={isDownloading} type="button" variant="link" className="link" onClick={props.onExportCSV}>
                  <FontAwesomeIcon size="lg" icon={faFileCsv} />
                </Button>
                {/* <Button disabled={isDownloading} type="button" variant="link" className="link" onClick={props.onExportCSV}>
                  <FontAwesomeIcon size="lg" icon={faFilePdf} />
                </Button>
                <Button disabled={isDownloading} type="button" variant="link" className="link" onClick={props.onExportCSV}>
                  <FontAwesomeIcon size="lg" icon={faFileExcel} />
                </Button> */}
              </Col>
            </Row>
            {/* <Row>
              
            </Row> */}
          {/* </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion> */}
      
    </React.Fragment> 
  );
}
export default Filter;